import { nanoid } from 'nanoid';
import { Node } from 'slate';

import { ELEMENT_OUTLINE_STATEMENT } from './OutlineStatementPlugin.types';

function createOutlineStatementNode({ text = 'Statement' }) {
  return {
    id: nanoid(),
    type: ELEMENT_OUTLINE_STATEMENT,
    children: [{ text }],
  } as Node;
}

export const outlineStatementTransforms = {
  createOutlineStatementNode,
};
